'use strict';

exports.array = require('./array');
exports.matrix = require('./matrix');



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-stat/index.js
 ** module id = 24
 ** module chunks = 0
 **/